import clsx from "clsx";

import styles from "./divider.module.scss";

const Divider = ({ className }) => {
  return <hr className={clsx(styles.Divider, className)} />;
};

export default Divider;
